import { quickNews } from '@/mocks/gua';

const footNav = [
  { href: '#hot', label: '今日热搜' },
  { href: '#timeline', label: '事件时间线' },
  { href: '#review', label: '全经过复盘' },
  { href: '#topic', label: '瓜田分类' },
  { href: '#faq', label: '常见问题' },
  { href: '#about', label: '关于本站' },
];

export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-200/70">
      <div className="container-x grid grid-cols-1 gap-8 py-12 md:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <a href="#top" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-eye-fill text-lg" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-xl font-bold text-foreground-950">每日看瓜</span>
          </a>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700">
            把复杂瓜田捋成清晰时间线，从起因到结局、始末细节一次讲透，帮你快速补完全部背景。
          </p>
          <p className="mt-4 flex items-center gap-2 text-sm text-foreground-700">
            <i className="ri-mail-line text-primary-600" aria-hidden="true"></i>
            <a href="mailto:hello@example.com" className="transition-colors hover:text-primary-600">
              hello@example.com
            </a>
          </p>
        </div>

        <div>
          <h4 className="font-label text-sm font-semibold uppercase tracking-wide text-foreground-950">站内导航</h4>
          <ul className="mt-4 flex flex-wrap gap-x-6 gap-y-3">
            {footNav.map((l) => (
              <li key={l.href} className="w-full sm:w-auto">
                <a href={l.href} className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-label text-sm font-semibold uppercase tracking-wide text-foreground-950">热门分类</h4>
          <ul className="mt-4 space-y-2.5">
            {['明星娱乐', '综艺现场', '商业财经', '社会民生', '直播网红'].map((c) => (
              <li key={c}>
                <a href="#topic" className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                  {c}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-label text-sm font-semibold uppercase tracking-wide text-foreground-950">瓜田速报</h4>
          <ul className="mt-4 space-y-3">
            {quickNews.slice(0, 4).map((n) => (
              <li key={n.id} className="flex items-start gap-2">
                <span className="mt-1 flex h-1.5 w-1.5 shrink-0 rounded-full bg-accent-500"></span>
                <a href="#hot" className="line-clamp-2 text-sm leading-snug text-foreground-700 transition-colors hover:text-primary-600">
                  {n.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-background-300/60">
        <div className="container-x flex flex-col gap-2 py-5 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-secondary-700">© {new Date().getFullYear()} 每日看瓜 · 内容仅供参考，请理性看待网络信息。</p>
          <p className="text-xs text-secondary-600">每天为你把瓜田捋得明明白白</p>
        </div>
      </div>
    </footer>
  );
}